<template>
  <label :for="props.for" :class="[props.classLabel, props.required ? 'required' : '']">
    {{ props.label }}
  </label>
</template>

<script setup lang="ts">
  const props = defineProps({
    for: String,
    label: String,
    classLabel: String,
    required: {
      type: Boolean,
      default: false,
    },
  });
</script>
